import "./ContactPage.css";
import emailjs from "@emailjs/browser";
import { useState } from "react";
import TextBoxMessage from "../../components/TextBoxMessage/TextBoxMessage";
import { contacts } from "../../information/information";

import { Grid, Typography } from "@mui/material";
function ContactPage() {
  const {title,paragraph} = contacts;
  return (
    <Grid container gap={3} direction={'column'} id="ContactPage">
      <Grid item>
              <Typography variant="h3" className="title">
                {title}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1" className="about_paragraph">
                {paragraph}
              </Typography>
            </Grid>
      <Grid item justifySelf={'center'}>
      <TextBoxMessage />
      </Grid>
    </Grid>
  );
}

export default ContactPage;
